<template>
  <section
    class="app-section app-section-light-grey container-fluid pt-0 pl-0 pr-0 pb-0 ml-0 mr-0 g-0"
  >
    <PageLayout :screenWidth="windowWidth" :loaded="meta.loaded">
      <b-container id="edit-column-width" class="container whhhzzzaaaaaaaaaaaa">
        <h1
          class="section-heading"
          style="margin-bottom:1%"
          @click="clickToRegister()"
        >
          Trailfinders Honeymoon Wishlists & Celebration Wishlists <br />
          <p class="fs-4 pt-2 subheading-normal-case">Find out more &amp; Sign up</p>
          <!-- <b-nav-item style="padding-bottom: 0px" exact exact-active-class="active" class="btn" to="/the-happy-couple/register" ></b-nav-item> -->
        </h1>

        <b-container fluid class="p-4">
          <b-row>
            <b-col sm="1"></b-col>
            <b-col
              lg="5"
              @click="registerForm('wedding')"
              style="cursor: pointer;"
            >
              <div class="card border-0 rounded-0 shadow my-3">
                <figure class="has-object-fit has-caption border-light">
                  <div class="img-caption d-block h-100">
                    <div
                      class="caption-cell d-flex h-100 justify-content-center align-items-center w-100"
                    >
                      <div class="cell-inner w-100">
                        <h5>Honeymoons</h5>
                      </div>
                    </div>
                  </div>
                  <img
                    src="https://www.trailfinders.com/graphics/honeymoons/heart_on_beach1.jpg"
                    data-src="https://www.trailfinders.com/graphics/honeymoons/heart_on_beach1.jpg"
                    class="img-fluid img-grow lazy"
                    alt="Honeymoons"
                    title="Honeymoons"
                  />
                </figure>
              </div>
            </b-col>
            <b-col
              lg="5"
              @click="registerForm('celebration')"
              style="cursor: pointer;"
            >
              <div class="card border-0 rounded-0 shadow my-3">
                <figure class="has-object-fit has-caption border-light">
                  <div class="img-caption d-block h-100">
                    <div
                      class="caption-cell d-flex h-100 justify-content-center align-items-center w-100"
                    >
                      <div class="cell-inner w-100">
                        <h5>Celebrations</h5>
                      </div>
                    </div>
                  </div>
                  <img
                    src="https://www.trailfinders.com/graphics/honeymoons/champagne_glasses1.jpg"
                    data-src="https://www.trailfinders.com/graphics/honeymoons/champagne_glasses1.jpg"
                    class="img-fluid img-grow lazy"
                    alt="Champagne Glasses"
                    title="champagne_glasses"
                  />
                </figure>
              </div>
              <!-- <div>
              <b-img class="landing-giftlist-image" style="cursor: pointer;" thumbnail fluid src="https://webimages.trailfinders.com/image/upload/l_text:Alegreya_500:%20Celebrations%20,g_south,b_rgb:f8f9fa,y_0.75,bo_8px_solid_black,r_50/champagne_glasses.jpg" alt="Image 2" @click="registerForm('celebration')"></b-img>
            </div> -->
            </b-col>
          </b-row>
        </b-container>

        <b-card class="landing-login-bcard">
          <h1 class="section-heading" style="margin-bottom:1%">
            View Your Wishlist
          </h1>

          <b-row align-content="center" style="padding-top:1%;margin-left: 0%;">
            <b-col
              style="margin-left:0%;  padding-left: 0%;  margin-top:1%;"
              id="right"
              sm="4"
            >
              <b-form-input
                v-model.trim="surname"
                id="surname"
                size="lg"
                style=" border-radius:5px"
                placeholder="Surname"
                :state="validateState('surname')"
                @change="touchField(surname)"
              >
              </b-form-input>
              <div
                class="alert alert-danger m-b-0"
                v-if="$v.surname.$invalid && !$v.surname.required"
              >
                Field is required
              </div>
            </b-col>

            <b-col sm="4" style="padding-left:0px;  margin-top:1%;">
              <b-form-input
                v-model.trim="reference"
                id="reference"
                size="lg"
                style=" border-radius:5px"
                placeholder="Reference"
                :state="validateState('reference')"
                @change="touchField(reference)"
              >
              </b-form-input>
              <div
                class="alert alert-danger m-b-0"
                v-if="$v.reference.$invalid && !$v.reference.required"
              >
                Field is required
              </div>
            </b-col>

            <b-col sm="4" style=" padding-left: 0%;  margin-top:1%;">
              <b-form-input
                v-model.trim="clientNo"
                id="clientNo"
                name="clientNo"
                size="lg"
                style=" border-radius:5px"
                placeholder="Client Number"
                aria-describedby="input-2-live-feedback"
                :state="validateState('clientNo')"
                @change="touchField(clientNo)"
              >
              </b-form-input>
              <div
                class="alert alert-danger m-b-0"
                v-if="$v.clientNo.$invalid && !$v.clientNo.required"
              >
                Field is required
              </div>
            </b-col>
          </b-row>

          <b-row align-content="center" style="padding-top:1%;">
            <b-col style="margin-left:0%;  padding-left: 0%;" id="right" sm="4">
            </b-col>

            <b-col sm="4" style="" class="text-center">
              <b-button
                v-if="$store.state.wishlistType === 'wishlist'"
                style="background-color: pink; color: white; border: none; border-radius: 0% !important; width:58%;"
                class="btn btn-primary mt-2"
                @click="userLogin()"
                >Login</b-button
              >
              <b-button
                v-else
                style="background-color: orange; color: white; border: none; border-radius: 0% !important; width:58%;"
                class="btn btn-primary mt-2"
                @click="userLogin()"
                >Login</b-button
              >
            </b-col>
            <b-col v-if="loginError" sm="12">
              <div class="alert alert-danger m-b-0 mt-3 text-center">
                {{ errMsg }}
              </div>
            </b-col>
            <b-col v-if="showIEWarning" sm="12">
              <div class="alert alert-danger m-b-0 mt-3 text-center">
                The booking you are trying to access is an Irish Booking please
                click
                <a
                  style="font-size:15px !important;"
                  href="https://www.trailfinders.ie/wishlist#/"
                  >here</a
                >
                to login
              </div>
            </b-col>
            <b-col v-if="showUKWarning" sm="12">
              <div class="alert alert-danger m-b-0 mt-3 text-center">
                The booking you are trying to access is an UK Booking please
                click
                <a
                  style="font-size:15px !important;"
                  href="https://www.trailfinders.com/wishlist#/"
                  >here</a
                >
                to login
              </div>
            </b-col>

            <b-col style="margin-left:0%;  padding-left: 0%;" id="right" sm="4">
            </b-col>
          </b-row>
        </b-card>

        <b-card class="landing-guest-bcard">
          <h1 class="section-heading" style="margin-bottom:1%">
            Make a Contribution to a Wishlist
          </h1>

          <b-row align-content="center" style="padding-top:1%; ">
            <b-col sm="2" />

            <b-col style="margin-left:0%;  margin-top:1%;" id="right" sm="4">
              <b-form-input
                v-model.trim="guestSurname"
                id="example-input-3"
                size="lg"
                style=" border-radius:5px"
                placeholder="Surname"
                :state="validateState('guestSurname')"
                @change="touchField(guestSurname)"
              >
              </b-form-input>
              <div
                class="alert alert-danger m-b-0"
                v-if="$v.guestSurname.$invalid && !$v.guestSurname.required"
              >
                Field is required
              </div>
            </b-col>

            <b-col sm="4" style="margin-left:0%; margin-top:1%;">
              <b-form-input
                v-model.trim="guestReference"
                id="guestReference"
                size="lg"
                style=" border-radius:5px"
                placeholder="Reference"
                :state="validateState('guestReference')"
                @change="touchField(guestReference)"
              >
              </b-form-input>
              <div
                class="alert alert-danger m-b-0"
                v-if="$v.guestReference.$invalid && !$v.guestReference.required"
              >
                Field is required
              </div>
            </b-col>
          </b-row>

          <b-row align-content="center" style="padding-top:1%;">
            <b-col style="margin-left:0%;  padding-left: 0%;" id="right" sm="4">
            </b-col>

            <b-col sm="4" style="" class="text-center">
              <b-button
                v-if="$store.state.wishlistType === 'wishlist'"
                @click="guestLogin()"
                style="background-color: pink; color: white; border: none; border-radius: 0% !important; width:58%;"
                class="btn btn-primary mt-2"
                >Login</b-button
              >
              <b-button
                v-else
                @click="guestLogin()"
                style="background-color: orange; color: white; border: none; border-radius: 0% !important; width:58%;"
                class="btn btn-primary mt-2"
                >Login</b-button
              >
            </b-col>
            <b-col v-if="guestLoginError" sm="12">
              <div class="alert alert-danger m-b-0 mt-3">
                There has been an error logging in to this Wishlist please call
                us on {{ telNo }}
              </div>
            </b-col>
            <b-col v-if="showGuestIEWarning" sm="12">
              <div class="alert alert-danger m-b-0 mt-3 text-center">
                The booking you are trying to access is an Irish Booking please
                click
                <a
                  style="font-size:15px !important;"
                  href="https://www.trailfinders.ie/wishlist#/"
                  >here</a
                >
                to login
              </div>
            </b-col>
            <b-col v-if="showGuestUKWarning" sm="12">
              <div class="alert alert-danger m-b-0 mt-3 text-center">
                The booking you are trying to access is an UK Booking please
                click
                <a
                  style="font-size:15px !important;"
                  href="https://www.trailfinders.com/wishlist#/"
                  >here</a
                >
                to login
              </div>
            </b-col>

            <b-col style="margin-left:0%;  padding-left: 0%;" id="right" sm="4">
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </PageLayout>
  </section>
</template>

<script>
import moment from "moment";
import { validationMixin } from "vuelidate";
import { requiredIf } from "vuelidate/lib/validators";
import { loginCheck, login, guestLogin } from "../../services/api";

export default {
  mixins: [validationMixin],
  data() {
    return {
      meta: {
        loaded: true
      },
      date: null,
      loginError: false,
      guestLoginError: false,
      slide: 0,
      colWidth: "",
      sliding: null,
      site: "UK",
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      userData: "",
      telNo: "",
      guestSurname: "",
      guestReference: "",
      surname: "",
      reference: "",
      errMsg: "",
      clientNo: "",
      guestForm: false,
      guestIstNotValid: false,
      userForm: false,
      isNotValid: false,
      showUKWarning: false,
      showIEWarning: false,
      showGuestUKWarning: false,
      showGuestIEWarning: false
    };
  },
  validations: {
    guestSurname: {
      required: requiredIf(function() {
        return this.guestForm === true;
      })
    },
    guestReference: {
      required: requiredIf(function() {
        return this.guestForm === true;
      })
    },
    surname: {
      required: requiredIf(function() {
        return this.userForm === true;
      })
    },
    reference: {
      required: requiredIf(function() {
        return this.userForm === true;
      })
    },
    clientNo: {
      required: requiredIf(function() {
        return this.userForm === true;
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  mounted() {
    if (window.location.toString().indexOf("trailfinders.ie") > 0) {
      this.telNo = "01 881 4990";
      this.site = "IE";
    } else if (this.$store.state.wishlistType === "giftlist") {
      this.telNo = "020 7408 9008";
    } else {
      this.telNo = "020 7084 6512";
    }
    this.meta.loaded = true;
    this.date = Date.now();
  },

  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      if (window.innerWidth < 1040) {
        this.colWidth = "12";
      } else {
        this.colWidth = "8";
      }
      return this.colWidth;
    },
    clickToRegister() {
      this.$router.push({ path: `/honeymoon/register` });
    },
    registerForm(type) {
      if (type === "wedding") {
        this.$router.push({ path: `/honeymoon/register` });
      } else {
        this.$router.push({ path: `/giftlist/register` });
      }
    },
    async userLogin() {
      this.isNotValid = false;
      this.loginError = false;
      this.userForm = true;
      this.guestForm = false;
      this.showUKWarning = false;
      this.showIEWarning = false;
      this.showGuestUKWarning = false;
      this.showGuestIEWarning = false;
      if (!this.$v.$invalid) {
        let data = {
          surname: this.surname,
          client_number: this.clientNo,
          reference: this.reference
        };
        if (this.site === "IE" && this.reference[0].toUpperCase() !== "R") {
          this.showUKWarning = true;
        } else if (
          this.site === "UK" &&
          this.reference[0].toUpperCase() === "R"
        ) {
          this.showIEWarning = true;
        } else {
          let check = await loginCheck(data, "event");
          if (check.error) {
            this.loginError = true;
            this.errMsg = `There has been error logging in to your Wishlist please call us on ${this.telNo}`;
          } else {
            let wishlistType;
            if (check.data === "OK") {
              wishlistType = "wishlist";
            } else {
              wishlistType = "giftlist";
            }
            let res = await login(data, wishlistType);
            if (res.error || res.message) {
              this.loginError = true;
              this.errMsg = `Sorry there was a problem logging in: Event not found in system.`;
            } else {
              this.$store.dispatch("setWishlistTypeAction", wishlistType);
              this.$store.dispatch("setUserAction", res.data);

              this.$router.push({ path: `/event/couples-admin` });
            }
          }
        }
      } else {
        this.isNotValid = true;
      }
    },
    async guestLogin() {
      this.guestIstNotValid = false;
      this.guestForm = true;
      this.userForm = false;
      this.guestLoginError = false;
      this.showUKWarning = false;
      this.showIEWarning = false;
      this.showGuestUKWarning = false;
      this.showGuestIEWarning = false;
      if (this.site === "IE" && this.guestReference[0].toUpperCase() !== "R") {
        this.showGuestUKWarning = true;
      } else if (
        this.site === "UK" &&
        this.guestReference[0].toUpperCase() === "R"
      ) {
        this.showGuestIEWarning = true;
      } else {
        if (!this.$v.$invalid) {
          let data = {
            surname: this.guestSurname,
            reference: this.guestReference
          };
          let check = await loginCheck(data, "guest");
          if (check.error) {
            this.guestLoginError = true;
          } else {
            let res = await guestLogin(
              data,
              check.data._event[0].wishlist_type
            );
            if (res.error || res.message) {
              this.guestLoginError = true;
            } else {
              this.$store.dispatch(
                "setWishlistTypeAction",
                check.data._event[0].wishlist_type
              );
              this.$store.dispatch("setUserAction", res.data);
              this.guestForm = false;
              this.$router.push({ path: `/event/friends-and-family` });
            }
          }
        } else {
          this.guestIstNotValid = true;
        }
      }
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    touchField: function(field) {
      if (field && typeof field.touch === "function") {
        field.touch();
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.subheading-normal-case {
  text-transform: none;
}
.express-vue-temp a {
  color: black !important;
  text-decoration: none;
  background-color: transparent;
  font-size: 27px;
}
.express-vue-temp a:hover {
  color: #ffa409 !important;
}
.landing-wishlist-image {
  margin-right: 1%;
  margin-left: 12%;
  max-width: 88%;
}

.landing-wishlist-image:hover {
  opacity: 70%;
}
.landing-giftlist-image {
  max-width: 88%;
}
.landing-giftlist-image:hover {
  opacity: 70%;
}
.landing-login-bcard {
  padding-top: 2%;
  background-color: #f8f9fa !important;
  padding-bottom: 2%;
  margin-left: 9%;
  width: 82%;
}
.landing-guest-bcard {
  padding-top: 2%;
  background-color: #f8f9fa !important;
  margin-top: 2%;
  padding-bottom: 2%;
  margin-left: 9%;
  width: 82%;
  margin-bottom: 5%;
}
.express-vue-temp figure {
  margin: 0 0 0rem;
}
@media only screen and (max-width: 1024px) {
  .landing-wishlist-image {
    margin-right: 2%;
    margin-left: 2%;
    max-width: 100%;
  }
  .landing-giftlist-image {
    margin-right: 2%;
    margin-left: 2%;
    max-width: 100%;
  }

  .landing-login-bcard {
    padding-top: 2%;
    background-color: #f8f9fa !important;
    padding-bottom: 2%;
    margin-left: 3%;
    width: 94%;
  }
  .landing-guest-bcard {
    padding-top: 2%;
    background-color: #f8f9fa !important;
    margin-top: 2%;
    padding-bottom: 2%;
    margin-left: 3%;
    width: 94%;
    margin-bottom: 5%;
  }
}
</style>
